



























import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { VHeaders, RepairOrderPagedListModel } from '@/models/pagedlistmodel';
import {
  RepairOrderListViewModel,
  SearchRepairOrderViewModel,
  AddAttachmentModel,
  AttachmentInfoViewModel,
  RepairOrderResponseViewModel,
} from '@/models/fixedops/repairorder';
import { VFields } from '@/models/v-fields';
import { AttachmentType } from '@/models/fixedops/attachment';
import { addAttachmentsFields } from '@/models/formly.fields';
import { Base } from '../common/base';
import { attachmentTypeService, repairOrderService } from '@/shared';
import { IDialogOption } from '@/models/dialog';
import { FileHelper } from '@/helper/file.helper';

@Component({
  props: [
    'searchedRepairOrder',
    'roNumber',
    'openRepairOrders',
    'methodName',
    'childProgress',
  ],
  computed: {
    methodtoCall: {
      get() {
        return this.$props.methodName;
      },
    },
  },
  components: {
    AppDialog: () => import('../common/app.dialog.vue'),
    Grid: () => import('@/components/common/app.grid.vue'),
    AttachmentGrid: () => import('./attachment.grid.vue'),
  },
})
class SaveAttachmentComponent extends Base {
  public form: any = {};
  public formFields: Array<VFields<any>> = [];
  public flags: any = {
    showForm: false,
    showAttachmentDetails: false,
    showEmailPopup: false,
    showCallGrid: true,
    showTextGrid: true,
    showAttachmentGrid: true,
  };
  public isPageLoading: boolean = true;
  public roNumber: string;
  public repairOrder: any;
  public preventPaginationCall: boolean = false;
  public fileRef: any;

  public searchedRepairOrder: SearchRepairOrderViewModel;
  public openRepairOrders: RepairOrderPagedListModel<RepairOrderListViewModel>;
  public addAttachmentTypeModel: AddAttachmentModel = { isPublic: false };
  public attachmentDetails: AttachmentInfoViewModel[] = [];
  public attachmentTypes: AttachmentType[] = [];
  public disableSubmitButton: boolean = false;
  public fileBunkerGridLoading: boolean = false;
  public fileBunkerProcessItems: any[] = [];
  public fileBunkerProcessHeaders: VHeaders[] = [
    {
      text: "FileName",
      align: 'left',
      value: 'fileName',
      sortable: true,
    },
    {
      text: "Started At",
      align: 'left',
      value: 'createdAt',
      fieldType: 'date',
      sortable: true,
    }
  ];

  public fileProgressDialog: IDialogOption = {
    width: 800,
    title: 'RO Attachments upload in progress',
    model: false,
    loading: false,
  };

  public headers: VHeaders[] = [
    { align: 'left', sortable: false, text: 'RO#', value: 'repairOrderNumber' },
    {
      align: 'left',
      sortable: false,
      text: 'Customer Name',
      value: 'customerName',
    },
    { align: 'left', sortable: false, text: 'VIN', value: 'vin' },
    {
      align: 'left',
      sortable: false,
      text: 'Close Date',
      value: 'finalCloseDate',
      fieldType: 'date',
    },
    {
      align: 'left',
      sortable: false,
      text: 'Status',
      value: `finalCloseDate?'Closed':'Open'`,
    },
    {
      align: 'left',
      sortable: false,
      text: 'Service Writer',
      value: `serviceWriter`,
    },
    { align: 'center', sortable: false, text: 'Action', isNotDataProp: true },
  ];

  public beforeDestroy() {
    const buttons = [];
    this.$emit('updateToolBar', buttons);
  }
  public callMethod(methodName): void {
    if (methodName === 'backToList') {
      this.cancel();
    } else if (methodName === 'saveAttachment') {
      if (this.form.$valid) {
        this.saveAttachment();
      } else {
        this.showAlert(
          false,
          this.$t('repairOrderAttachments.alertFormIsInvalid')
        );
      }
    }

    if (methodName !== '') {
      this.$emit('resetMethodName', methodName);
    }
  }

  public updateToolBar(): void {
    const buttons: any = [];
    buttons.push({
      id: '0',
      type: 'button',
      title: this.$parent.$t(
        'repairOrderAttachments.btnBackToListTitle'
      ) as string,
      disabled: false,
      visible: true,
      class: 'btn',
      label: this.$parent.$t('repairOrderAttachments.btnBackToList') as string,
      click: 'backToList',
      icon: 'fas fa-arrow-left',
    });
    this.$emit('updateChildToolBar', buttons);
  }

  public async mounted(): Promise<void> {
    // Toolbar
    this.isPageLoading = true;
    this.updateToolBar();
    this.$watch('methodtoCall', (newVal, oldVal) => {
      if (newVal) {
        this.callMethod(newVal);
      }
    });
    if (this.roNumber) {
      await this.attachmentByRoNumber(this.roNumber);
    }

  }
  public async attachmentByRoNumber(roNumber): Promise<void> {
    if (this.searchedRepairOrder) {
      this.repairOrder = this.searchedRepairOrder.repairOrderList.find((m) => {
        return m.repairOrderNumber === roNumber;
      });
    } else {
      this.repairOrder = this.openRepairOrders.results.find((m) => {
        return m.repairOrderNumber === roNumber;
      });
    }
    if (this.repairOrder) {
      this.repairOrder.storeName = (
        this.searchedRepairOrder || this.openRepairOrders
      ).storeName;
      this.repairOrder.showCallDetails = (
        this.searchedRepairOrder || this.openRepairOrders
      ).showCallDetails;
      await this.viewAttachment(this.repairOrder);
    }
  }
  public async viewAttachment(model): Promise<void> {
    this.isPageLoading = true;
    this.addAttachmentTypeModel = {
      customerName: model.customerName,
      roNumber: model.repairOrderNumber,
      vehicleIdNumber: model.vin,
      attachmentTypeId: 0,
      comment: '',
      file: '',
      fileExtension: '',
      make: model.make,
      model: model.model,
    };

    this.setFields(() => { });

    await Promise.all([
      this.getAttachmentTypes(),
      this.getAttachmentDetails()
    ]);
    this.isPageLoading = false;
  }
  public async getAttachmentTypes(): Promise<void> {
    try {
      this.formlyShowSkeleton(this.formFields);
      const response = await attachmentTypeService.getAttachmentTypesListAsync();
      this.attachmentTypes = response.results;
      this.setAttachmentTypeItems('attachmentTypeId', this.attachmentTypes);
    } finally {
      this.formlyHideSkeleton(this.formFields);
    }
  }
  public setAttachmentTypeItems(fieldname: string, value: any[]) {
    const field = this.formFields.find((m) => {
      return m.key === fieldname;
    });
    if (field) {
      field.templateOptions.items = value;
    }
  }

  public validateAttachment(): Vue & { validate: () => boolean } {
    return this.$refs.attachmentForm as Vue & { validate: () => boolean };
  }

  public async saveAttachment(): Promise<void> {
    if (this.validateAttachment().validate()) {
      try {
        this.disableSubmitButton = true;
        this.$emit('update:childProgress', this.disableSubmitButton);
        await repairOrderService.addAttachment(this.addAttachmentTypeModel);
        this.showAlert(
          true,
          this.$t('repairOrderAttachments.alertAttachmentCreated')
        );
        this.addAttachmentTypeModel.file = null;
        this.addAttachmentTypeModel.attachmentTypeId = 0;
        this.addAttachmentTypeModel.comment = '';
        if (this.fileRef) {
          this.fileRef.clear();
        }
        await this.getAttachmentDetails();
      } finally {
        this.disableSubmitButton = false;
        this.$emit('update:childProgress', this.disableSubmitButton);
      }
    }
  }
  public async getAttachmentDetails(): Promise<void> {
    try {
      this.formlyShowSkeleton(this.formFields);
      const response = await repairOrderService.getAttachmentDetails(
        this.roNumber,
        this.addAttachmentTypeModel.vehicleIdNumber
      );
      this.attachmentDetails = response.results;
      this.attachmentDetails = this.attachmentDetails.sort((a, b) => {
        if (a.createdDateTime < b.createdDateTime) {
          // sort string ascending
          return 1;
        }
        if (a.createdDateTime > b.createdDateTime) {
          return -1;
        }
      });
    } finally {
      this.formlyHideSkeleton(this.formFields);
    }
  }
  public setFields(callback): void {
    var vm = this;
    this.formFields = [
      {
        key: 'roNumber',
        type: 'v-alynk-text-field',
        required: true,
        templateOptions: {
          counter: 50,
          label: vm.$parent.$t('repairOrderAttachments.roNumber') as string,
          required: true,
          disabled: true,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 float-left',
          loading: false,
          rules: [
            v => vm.required('Ro Number', v)
          ]
        },
      },
      {
        key: 'customerName',
        type: 'v-alynk-text-field',
        required: true,
        templateOptions: {
          label: vm.$parent.$t('repairOrderAttachments.customerName') as string,
          required: true,
          disabled: true,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 float-left',
          loading: false,
          rules: [
            v => vm.required('Customer Name', v)
          ]
        },
      },
      {
        key: 'vehicleIdNumber',
        type: 'v-alynk-text-field',
        required: true,
        templateOptions: {
          label: vm.$parent.$t('repairOrderAttachments.vinNumber') as string,
          required: true,
          disabled: true,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 float-left',
          loading: false,
          rules: [
            v => vm.required('VIN Number', v)
          ]
        },
      },
      {
        key: 'make',
        type: 'v-alynk-text-field',
        required: false,
        templateOptions: {
          label: vm.$parent.$t('repairOrderAttachments.make') as string,
          required: false,
          disabled: true,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 float-left',
          loading: false,
          // rules:[
          //     v => vm.required('Make',v)
          // ]
        },
      },
      {
        key: 'model',
        type: 'v-alynk-text-field',
        required: false,
        templateOptions: {
          label: vm.$parent.$t('repairOrderAttachments.model') as string,
          required: false,
          disabled: true,
          elementClass: 'col-12 col-xs-6 col-sm-6 col-md-3 col-lg-3 float-left',
          loading: false,
          // rules:[
          //     v => vm.required('Model',v)
          // ]
        },
      },
      {
        key: 'attachmentTypeId',
        type: 'v-alynk-select',
        required: true,
        templateOptions: {
          label: vm.$parent.$t('repairOrderAttachments.attachmentType') as string,
          // validations: 'required',
          required: true,
          disabled: false,
          time: true,
          value: 'id',
          text: 'name',
          items: vm.attachmentTypes,
          elementClass: 'col-12 col-xs-6 col-sm-6 col-md-3 col-lg-3 float-left',
          altag: 'Attachment Type',
          loading: false,
          rules: [
            v => vm.required('Attachment Type', v)
          ]
        },
      },
      {
        key: 'isPublic',
        type: 'v-alynk-switch',
        required: false,
        templateOptions: {
          label: vm.$parent.$t('repairOrderAttachments.isPublic') as string,
          disabled: false,
          validations: '',
          loading: false,
          elementClass: 'col-12 col-xs-6 col-sm-6 col-md-3 col-lg-3 float-left',
        },
      },
      {
        key: 'file',
        type: 'v-alynk-file-upload',
        required: true,
        templateOptions: {
          label: vm.$parent.$t('repairOrderAttachments.attachment') as string,
          required: true,
          disabled: false,
          multiple: false,
          elementClass: 'mt-4',
          events: {
            onChange: (files, ref) => {
              if (files.length > 0) {
                this.disableSubmitButton = true;
                this.$emit('update:childProgress', this.disableSubmitButton);
                const field = this.formFields.find((m) => {
                  return m.key === "file";
                });
                if (field != null) {
                  field.templateOptions.disabled = true;
                }
                vm.fileRef = ref;
                // tslint:disable-next-line: max-line-length
                vm.addAttachmentTypeModel.fileExtension = files[0].file.name.substring(files[0].file.name.lastIndexOf('.'));
                FileHelper.getFileBytes(files[0].file, (base64) => {
                  if (base64 != null && base64 != "") {
                    vm.addAttachmentTypeModel.file = base64;
                    this.disableSubmitButton = false;
                    this.$emit('update:childProgress', this.disableSubmitButton);
                    if (field != null) {
                      field.templateOptions.disabled = false;
                    }
                  }
                });
              }
            },
          },
          loading: false,
          rules: [
            v => vm.required('Attachment', v)
          ]
        },
      },
      {
        key: 'comment',
        type: 'v-alynk-textarea',
        required: false,
        templateOptions: {
          counter: 250,
          maxlength: 250,
          label: vm.$parent.$t('repairOrderAttachments.comment') as string,
          required: false,
          disabled: false,
          loading: false,
          elementClass: 'col-12 float-left mt-4',
        },

      }];
    callback();
  }
  public updateFlag(flag, value): void {
    this.flags[flag] = value;
  }
  public cancel(): void {
    this.$emit('updateFlag', 'showForm', false);
    this.$destroy();
  }

  public async getFileProgress() {
    this.fileProgressDialog.model = true;
    await this.openFileBunkerDialog();
  }

  public async openFileBunkerDialog() {
    try {
      this.fileBunkerGridLoading = true;
      var response = await repairOrderService.getFileBunkerProcess();
      this.fileBunkerProcessItems = response;
    } finally {
      this.fileBunkerGridLoading = false;
    }

  }
}
export default SaveAttachmentComponent;
